<template>
  <Modal :title="title" :showModal="showModal" class="edit-design-form design-form large">
    <template v-slot:body>
      <div class="popup-wrap">
        <a href="#close" class="close-modal" data-dismiss="modal" @click.prevent="$emit('close', {})"></a>
        <Gallery :value="galleryConfig.gallery" :groups="galleryConfig.groups" :config="galleryConfig.config" />
        <div class="main-container d-block p-3">
          <Detail v-if="!editDetail" :config="{ storeId, designId, data, loaded }" @editDetail="editDetail = true" @change-preview="preview.selectedType = 'blueprint'"></Detail>
          <EditDetail v-else :config="{ storeId, designId, data }" @submitEditDetail="submitEditDetail" @cancelEditDetail="editDetail = false"></EditDetail>
          <div class="form-group w-100">
            <Comment :config="data"></Comment>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import Comment from './Comment.vue'
import Detail from './Detail.vue'
import EditDetail from './EditDetail.vue'
import Gallery from '@/components/Gallery.vue'
export default {
  mixins: [Event],
  components: {
    Gallery,
    Comment,
    Detail,
    EditDetail
  },
  data() {
    return {
      submited: false,
      editDetail: false,
      loaded: false,
      preview: {
        selectedIndex: null,
        selectedType: null
      }
    }
  },
  created() {
    this.store.commit('', {})
  },
  unmounted() {
    if (this.submited) {
      this.$emitter.emit('TableList.Refresh')
    }
  },
  computed: {
    title() {
      return 'Design'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    designId() {
      return this.config?.data?._id
    },
    getUri() {
      return `design/get/${this.designId}`
    },
    submitUri() {
      return `design/update/${this.designId}`
    },
    data() {
      return Object.assign(
        {
          more: {}
        },
        this.store.getter('', {})
      )
    },
    listStatus() {
      return this.data?.more || {}
    },
    galleryConfig() {
      let gallery = Object.entries(Object.assign(this.data.thumbnail ? [this.data.thumbnail] : [], this.data.gallery)).reduce((result, [, value]) => {
        result.push({
          items: [value],
          group: 'gallery'
        })
        return result
      }, [])

      gallery = Object.values(this.data.designs || []).reduce((result, value) => {
        result.push({
          items: [value],
          group: 'blueprint'
        })
        return result
      }, gallery)

      gallery = Object.values(this.data.artworks || []).reduce((result, value) => {
        result.push({
          items: [value],
          group: 'artwork'
        })
        return result
      }, gallery)

      return {
        gallery,
        groups: {
          gallery: {
            label: 'Gallery',
            priority: 10
          },
          blueprint: {
            label: 'Blueprint',
            priority: 15
          },
          artwork: {
            label: 'Artwork',
            priority: 12
          }
        },
        config: {
          fullScreen: true,
          background: true,
          thumbnail: true,
          showLabel: true,
          default: {
            selected: {
              group: this.preview.selectedType || 'gallery',
              index: this.preview.selectedIndex || 0
            }
          }
        }
      }
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.store.commit('', rawData.data)
        this.store.commit('extra_attributes', rawData.extra_attributes)
        this.loaded = true
      }
    },
    submitEditDetail(data) {
      if (_.isObjectLike(data)) {
        this.store.commit('', data)
        this.submited = true
      }
      this.editDetail = false
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.design-form {
  .main-container {
    border-left: 1px solid #dfdfdf;
  }
  .gallery-container {
    flex: 1;
    height: 100vh;
    overflow: hidden;
  }
}
</style>
